import api from "utils/api";

export const getEducatorPolicyTemplate = async () => {
  try {
    const response = await api.get("/educator-policy/template");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSignedEducatorPolicies = async () => {
  try {
    const response = await api.get("/educator-policy/signatures");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const uploadWorkAgreementTemplate = async (file) => {
  try {
    const formData = new FormData();
    formData.append("workAgreementPdf", file);
    const response = await api.post("/educator-policy/work-agreement", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const uploadEducatorPolicyTemplate = async (file) => {
  try {
    const formData = new FormData();
    formData.append("policyPdf", file);
    const response = await api.post("/educator-policy/template", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
